export default "__VITE_ASSET__DyBtzH1e__"